import React from 'react';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import { createStyles } from '@/contexts/theme-context';
import { Pressable } from 'react-native';
import { RepViewProspectRowData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';
import { ROW_HEIGHT } from '@/experiences/sales-portal/domain/prospects/screens/prospects/components/prospects-rep-view-table/prospects-rep-view-table-columns';
import { TableCell } from '@experiences/components/table/table-cell';
import { TableRow } from '@experiences/components/table/table-row';

interface ProspectsRepViewTableRowProps {
  index: number;
  onRowClick: (row: RepViewProspectRowData) => void;
  row: Row<RepViewProspectRowData>;
}

export const ProspectsRepViewTableRow =
  React.memo<ProspectsRepViewTableRowProps>(({ index, onRowClick, row }) => {
    const [styles, theme] = useStyles();

    const handlePress = () => {
      onRowClick(row.original);
    };

    const visibleCells = row.getVisibleCells();

    return (
      <Pressable
        accessibilityLabel={row.original.name}
        accessibilityRole="button"
        onPress={handlePress}
        style={styles.pressable}
      >
        {({ hovered }) => {
          const cellBackgroundColor = hovered
            ? theme.sk.color.bg.primary.hover
            : theme.sk.color.bg.primary.default;

          return (
            <TableRow index={index} style={styles.row}>
              {visibleCells.map(
                (cell: Cell<RepViewProspectRowData, unknown>) => (
                  <TableCell
                    cell={cell}
                    key={cell.id}
                    style={{ backgroundColor: cellBackgroundColor }}
                  >
                    {flexRender(cell.column.columnDef.cell, {
                      ...cell.getContext(),
                      index,
                    })}
                  </TableCell>
                ),
              )}
            </TableRow>
          );
        }}
      </Pressable>
    );
  });

const useStyles = createStyles(() => ({
  pressable: {
    cursor: 'pointer',
  },
  row: {
    minHeight: ROW_HEIGHT,
  },
}));
